var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('caidan',{staticClass:"CaiDan"}),_c('div',{attrs:{"id":"APP"}},[_c('router-view'),(!_vm.$route.meta.hideBottom)?_c('Bottom'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }